export const apiEndpoints = {
    RaportsService: {
        apiUrlGetList: 'api/Reports',
        apiUrlGet: 'api/Reports/Fetch',
        apiUrlLogReport: 'api/AuditLogs/Report',
    },
    DataService: {
        apiUrlGet: 'api/Stores/get',
        apiUrlCreate: 'api/stores/create',
        apiUrlDelete: 'api/stores/delete',
        apiUrlUpdate: 'api/stores/update',
    },
    ProductsDataService: {
        apiUrlGet: 'api/products/get',
        apiUrlGetList: 'api/products',
        apiUrlGetDetails: 'api/products/details',
        apiUrlGetProductPrices: 'odata/ProductPrice',
        apiUrlCreate: 'api/products/create',
        apiUrlDelete: 'api/products/delete',
        apiUrlUpdate: 'api/products/update',
        apiUrlGetPrices: 'odata/EditablePrices',
        apiUrlSetPrice: 'api/prices/',
        apiUrlGetStorePrices: 'api/products/details',
        // product logics
        apiUrlProductLogicsInitMain: 'api/ProductLogicRelation/Product',
        apiUrlProductLogicsMainDependenciesList:
            'api/productlogicrelation/product',
        apiUrlProductLogicsMainForDependent: 'api/productlogicrelation/product',
        apiUrlProductLogicsProductsList: 'api/productlogicrelation',
        apiUrlProductLogicsMainRelationCreate:
            'api/ProductLogicRelation/Update',
    },
    CartsDataService: {
        apiUrlGetList: 'api/baskets',
        apiUrlGetDescription: 'api/baskets/details',
        apiUrlGetListFromIds: 'odata/GetManyBaskets',
        apiUrlGetSelectedProducts: 'api/baskets/details',
        apiUrlGetProducts: 'api/baskets/products',
        apiUrlCreate: 'api/baskets/create',
        apiUrlDelete: 'api/baskets/delete',
        apiUrlUpdate: 'api/baskets/update',
        apiUrlGetProductsId: 'odata/BasketProducts',
    },
    FeaturesDataService: {
        apiUrlGetList: 'api/attributes',
        apiUrlGetProductsList: 'api/attributes/products',
        apiUrlCreate: 'api/attributes/create',
        apiUrlUpdate: 'api/attributes/update',
        apiUrlDelete: 'api/attributes/delete',
        apiUrlSetProducts: 'api/attributes/products/set'
    },
    CategoriesDataService: {
        apiUrlGet: 'api/ProductHierarchies',
    },
    PricePlanDataService: {
        apiUrlGetList: 'api/prices/priceplans/current',
        apiUrlCreate: 'api/stores/create',
        apiUrlDelete: 'api/stores/delete',
        apiUrlUpdate: 'api/stores/update',
    },
    CurrentAssortmentService: {
        apiUrlGetAssortments: 'api/assortments',
        apiUrlGetAssortmentsCategories: 'api/assortments/categories',
        apiUrlGetAssortmentsDetails: 'api/assortments/category',
        apiUrlPostAssortment: 'api/assortments/assign',
    },
    PromotionsDataService: {
        apiUrlGetList: 'api/promotions',
        apiUrlGetDescription: 'api/promotions/details',
        apiUrlGetPromotionItems: 'api/promotions/details',
        apiUrlUpdate: 'api/Promotions/Update',
        apiUrlCreate: 'api/Promotions/Create',
        apiUrlDelete: 'api/Promotions/Delete',
    },
    StoresDataService: {
        apiUrlGetDescription: 'api/stores/details',
        apiUrlGetList: 'api/stores',
        apiUrlGetCompetitorsIDs: 'api/stores/details',
        apiUrlAssignCompStore: 'api/stores/competitors/assign',
        apiUrlCreate: 'api/stores/create',
        apiUrlDelete: 'api/stores/delete',
        apiUrlUpdate: 'api/stores/update',
        apiUrlGetFloorplan: 'api/stores/details',
        apiUrlDeleteFloorplan: 'api/stores/details',
        apiUrlGetCategoryShelves: 'api/shelves',
        apiUrlGetShelves: 'api/shelves',
        apiUrlGetShelvesDefinitions: 'api/shelves-definitions',
        apiUrlGetShelvesOdata: 'api/shelves-definitions',
        apiUrlUpdateCategoryShelves: 'api/shelves',
        apiUrlCreateShelf: 'api/shelves',
        apiUrlUpdateShelf: 'api/shelves',
        apiUrlDeleteShelf: 'api/shelves',
    },
    StoresGroupDataService: {
        apiUrlGetList: 'api/stores/groups',
        apiUrlGetById: 'api/stores/groups/details/',
        apiUrlCreateGroup: 'api/stores/groups/create',
        apiUrlUpdateGroup: 'api/stores/groups/update',
        apiUrlDeleteGroup: 'api/stores/groups/delete'
    },
    CompStoresDataService: {
        apiUrlGetDescription: 'api/compstores/details',
        apiUrlGetList: 'api/compstores',
        apiUrlGetOwnShopsIDs: 'api/compstores/details',
        apiUrlCreate: 'api/CompStores/create',
        apiUrlDelete: 'api/compstores/delete',
        apiUrlUpdate: 'api/CompStores/update',
    },
    SimulationDataService: {
        apiUrlGetList: 'api/simulations',
        apiUrlGetDescription: 'api/simulations/details',
        apiUrlGetResultsSummary: 'api/simulations/details',
        apiUrlGetDetails: 'api/simulations/details',
        apiUrlGetResultItems: 'api/simulations/details',
        apiUrlGetSummary: 'api/simulations/generate/summary',
        apiUrlSelectedApprove: 'api/simulationService/approveItems',
        apiUrlExecute: 'api/simulationService/execute',
        apiUrlApprove: 'api/simulationService/approve',
        apiUrlCancel: 'api/simulationService/cancel',
        apiUrlExportToCsv: 'api/simulationService/exportResultsToCsv',
        apiUrlExportToXML:
            'api/simulationService/ExportResultsWithStepsDetails',
        apiSaveChangePrices: 'api/simulationService/SetResultItemPriceList',
        apiUrlCreate: 'api/simulationService/create',
        apiUrlDelete: 'api/simulationService/delete',
        apiUrlUpdate: 'api/simulationService/update',
        apiUrlGetChartData: 'api/simulations/results/details',
    },
    PricesConfigDataService: {
        apiUrlCategoryRolesSave: 'api/PricesConfigurations/Roles',
        apiUrlElasticitySave: 'api/PricesConfigurations/Elasticity',
        apiUrlSensitivitySKUSave: 'api/PricesConfigurations/SKUSensitivity',
        apiUrlCategoryRolesResults: 'api/pricesconfigurations/results/productcategoryroles',
        apiUrlSensitivitySKUResults: 'api/pricesconfigurations/results/productsensitivities',
        apiUrlCatRolesResultsSave:
            'api/PricesConfigurations/ApproveCategoryRoleResults',
        apiUrlSensSKUResultsSave:
            'api/PricesConfigurations/ApproveProductSensitivityResults',
        apiUrlRolesCalcResults: 'api/products/CategoryRoles/Set',
        apiUrlSensCalcResults: 'api/products/SKUSensitivity/calculate',
        apiUrlGetSensTableSummaryDetails:
            'api/pricesconfigurations/results/productsensitivities/details',
        apiUrlGetRolesTableSummaryDetails:
            'api/pricesconfigurations/results/productcategoryroles/details',
        apiUrlGetJobStatus: 'api/jobs/details',
        apiUrlGetAssortmentsGoals: 'api/assortments/goals',
        apiUrlPostAssortmentTarget: 'api/assortments/goals'
    },
    ActiveUsersDataService: {
        apiUrlGetList: 'api/applicationsecurity/users',
        apiUrlGetActiveUser: 'api/applicationsecurity/users/details',
        apiUrlGetActiveUserGroups: 'api/applicationsecurity/users/details',
        apiUrlAssignUserToGroup: 'api/ApplicationSecurity/Groups/Members',
        apiUrlUserThumbnailPhoto: 'api/ApplicationSecurity/Users',
        apiUrlUserUpdate: 'api/ApplicationSecurity/Users/Profile',
    },
    AdUsersDataService: {
        apiUrlAdUsers: 'api/applicationsecurity/AdUsers',
        apiUrlAddUser: 'api/applicationsecurity/Users'
    },
    SecurityGroupsDataService: {
        apiUrlGetList: 'api/applicationsecurity/groups',
        apiUrlGetModuleList: 'api/applicationsecurity/permissions',
        apiUrlGetGroupPermissionsList:
            'api/applicationsecurity/groups/details',
        apiUrlGetGroupDetail: 'api/applicationsecurity/groups/details',
        apiUrlCreateGroup: 'api/ApplicationSecurity/Groups',
        apiUrlPatchGroupPermissions:
            'api/ApplicationSecurity/Groups/Permissions',
        apiUrlDeleteGroup: 'api/ApplicationSecurity/Groups',
        apiUrlAddDeleteGroupMember: 'api/ApplicationSecurity/Groups/Members',
    },
    ElasticityDataService: {
        apiUrlGetList: 'api/products/elasticities',
        apiUrlCalcResults: 'api/products/Elasticity/Calculate',
        apiUrlCalcDetails: 'api/products/elasticities/lastcalculation',
    },
    MainTableService: {
        apiUrlExport: 'api/FileExport',
    },
    ImportDialogService: {
        apiUrlImportTemplate: 'api/FileImport/Template',
        apiUrlImportFile: 'api/files/upload',
    },
    PricePointDataService: {
        apiUrlGetGroupsList: 'api/pricepoints/groups',
        apiUrlGetGroupDetails: 'api/pricepoints/groups/details',
        apiUrlGetGroupItems: 'api/pricepoints/groups/details',
        apiUrlUpdate: 'api/PricePoints/Update',
        apiUrlCreate: 'api/PricePoints/Create',
        apiUrlDelete: 'api/PricePoints/Delete',
    },
    PriceContractDataService: {
        apiUrlGetList: 'api/productpricecontracts/product',
        apiUrlUpdate: 'api/productpricecontracts/update',
        apiUrlCreate: '/api/productpricecontracts/create',
        apiUrlDelete: '/api/productpricecontracts/delete',
    },
    CompetitorsPricesDataService: {
        apiUrlGetList: 'api/competitorsprices',
        apiUrlGetImports: 'api/competitorsprices/imports',
        apiUrlGetImportDetails: 'api/CompetitorsPrices/ImportDetails',
        apiUrlApproveImportPrices: 'api/CompetitorsPrices/ApprovePrices',
        apiUrlDeleteImport: 'api/CompetitorsPrices/Import/Delete',
        apiUrlDeletePrice: 'api/CompetitorsPrices/DeletePrices',
    },
    MarginCalculatorDataService: {
        apiUrlGetPricesConfig: 'api/PricesConfigurations/MarginCalculator',
        apiUrlGetMargins: 'api/MarginCalculator',
        apiUrlUpdateMargins: 'api/MarginCalculator/UpdateMargins',
        apiUrlGetList: 'api/pricesconfigurations/margins',
        apiUrlGetById: 'api/pricesconfigurations/margins/details/',
        apiUrlUpdate: 'api/pricesconfigurations/margins/update',
        apiUrlCreate: 'api/pricesconfigurations/margins/create',
        apiUrlDelete: 'api/pricesconfigurations/margins/delete',
        apiUrlGetMarginsNew: 'api/products/categories/all',
    },
    FiltersDataService: {
        apiUrlGetList: 'api/FilterValues'
    },
    JobStatus: {
        apiUrlGetJobStatus: 'api/jobs/details',
    },
    ProfileDataService: {
        apiUrlGetProfile: 'api/Users/GetProfile/',
        apiUrlUpdateUserProfile: 'api/users/UpdateProfile',
        apiUrlGetProfilePermissionsList:
            'api/users/permissions',
    },
    NotificationDataService: {
        apiUrlGetNotification: 'api/notifications',
        apiUrlSetAsRead: 'api/Notifications/SetNotificationStatusAsRead',
        apiUrlConfigSetEnable: 'api/notifications/SetNotificationTypeAsEnabled',
        apiUrlConfigSetDisable:
            'api/notifications/SetNotificationTypeAsDisabled',
        apiUrlConfigRead: 'api/notifications/settings',
        apiUrlSetAsEnabled: 'api/notifications/enabled'
    },
    FilesService: {
        apiUrlGetFile: 'api/files/download',
    },
};
